export default "__VITE_ASSET__DXkqleUe__"